import { Component, Input } from '@angular/core';
import * as i0 from "@angular/core";
export class MissingComponentComponent {
    rendering;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MissingComponentComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: MissingComponentComponent, selector: "sc-missing-component", inputs: { rendering: "rendering" }, ngImport: i0, template: `
    <div
      style="background: darkorange; outline: 5px solid orange; padding: 10px; color: white; max-width: 500px;"
    >
      <h2>{{ rendering.componentName }}</h2>
      <p>JSS component is missing Angular component implementation.</p>
    </div>
  `, isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MissingComponentComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sc-missing-component',
                    template: `
    <div
      style="background: darkorange; outline: 5px solid orange; padding: 10px; color: white; max-width: 500px;"
    >
      <h2>{{ rendering.componentName }}</h2>
      <p>JSS component is missing Angular component implementation.</p>
    </div>
  `,
                }]
        }], propDecorators: { rendering: [{
                type: Input
            }] } });
